import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space, Table, Card, Tag, Badge, Empty } from 'antd';
import { useRef, useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import Highlighter from 'react-highlight-words';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { getBizID } from '../../libs/todoSlice';
import { setHistoryDetail, getHistoryDefault, getTrickerExcel, setHistoryDefault } from '../../libs/historySlice';
import { setManageMemberStep } from '../../libs/sideBarSlice';
import LoadingComponent from '../../lib/LoadingComponent';
import axios from 'axios';
import Swal from "sweetalert2";
import { downloadHistoryExcel } from '../../lib/exportHistoryExcel';

const AddHistory = () => {
  const dispatch = useDispatch()
  const [data, setData] = useState([])
  const business_id = useSelector(getBizID)
  const params = useParams()
  const navigate = useNavigate()
  const [all_history, setAllHistory] = useState(0)
  const [success_history, setSuccessHistory] = useState(0)
  const [fail_history, setFailHistory] = useState(0)
  const [loading, setLoading] = useState(false)
  const dataDefault = useSelector(getHistoryDefault)
  const trigger = useSelector(getTrickerExcel)

  const setDataDefault = (action) => {
    dispatch(setHistoryDefault({
      historyDefault: action
    }))
  }

  useEffect(() => {
    if (business_id) {
      getExcel()
    }
  }, [business_id, trigger])

  const isEmployeeObjective = (obj) => obj.includes('One ID') || obj.includes('CA') || obj.includes('one-id')
  const lastHistory = (item) => item.importHistories[item.importHistories.length - 1]

  const getExcel = async () => {
    setLoading(true)
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v5/excel`, {
        params: { business_id },
      })
      const excelList = data?.data?.excel
      if (!excelList) return

      const EmployeeExcel = excelList.filter((item) =>
        item.importHistories?.some((history) => (history.objective || []).some(isEmployeeObjective))
      )
      setAllHistory(EmployeeExcel.length)
      setSuccessHistory(EmployeeExcel.filter((item) => lastHistory(item).fail === '0').length)
      setFailHistory(EmployeeExcel.filter((item) => lastHistory(item).fail > 0).length)

      const prepareData = EmployeeExcel.map((excel, index) => {
        const last = lastHistory(excel)
        const create_date = new Date(excel.createdAt)
        const create_by = last.createdBy
        return {
          index: index + 1,
          operation_date: `${create_date.getDate()}/${create_date.getMonth() + 1}/${create_date.getFullYear()}`,
          count_member: last.total,
          objective: last.objective.join(', '),
          Operator: `${create_by?.account_title_th} ${create_by?.first_name_th} ${create_by?.last_name_th}`,
          status: last.total === last.success,
          excel,
        }
      })
      setData(prepareData)
      setDataDefault(prepareData)
    } catch (error) {
      if (error.response?.status === 401) navigate(`/${params.prefix}`)
    } finally {
      setLoading(false)
    }
  }

  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);

  const customLocale = {
    emptyText: (<Empty
      description="ไม่มีข้อมูล"
    />)
  };

  //csearch 
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });
  const columns = [
    {
      title: 'ลำดับ',
      width: 20,
      dataIndex: 'index',
      key: 'index',
      sorter: (a, b) => a.index - b.index,
      sortDirections: ['descend', 'ascend'],
      fixed: 'left',

    },
    {
      title: 'วันที่ดำเนินการ',
      width: 40,
      dataIndex: 'operation_date',
      // sorter: (a, b) => new Date(a.operation_date) - new Date(b.operation_date),
      // sortDirections: ['descend', 'ascend'],
      // fixed: 'left',
      // ...getColumnSearchProps('operation_date'),
    },
    {
      title: 'จำนวนรายชื่อ (รายการ)',
      width: 40,
      dataIndex: 'count_member',

      // fixed: 'left',
      // ...getColumnSearchProps('count_member'),
    },
    {
      title: 'ผู้ดำเนินการ',
      dataIndex: 'Operator',
      width: 70,

      // ...getColumnSearchProps('Operator'),
    },
    {
      title: 'ประเภท',
      dataIndex: 'objective',
      width: 70,
      // ...getColumnSearchProps('Operator'),
    },
    {
      title: 'สถานะล่าสุด',
      dataIndex: 'status',
      width: 40,
      render: (_, value) => {
        return (
          <>
            {value.status ?
              <Tag color="success">
                <Badge status="success" /> เพิ่มครบแล้ว
              </Tag>
              :
              <Tag color="warning">
                <Badge status="warning" /> ยังเพิ่มไม่ครบ
              </Tag>
            }
          </>
        )
      }
    },
    {
      title: 'Download Excel',
      width: 40,
      render: (_, value) => <Button onClick={() => downloadHistoryExcel(value.excel)}>Download</Button>,
    },
    {
      title: 'ส่ง Email ซ้ำ',
      width: 40,
      render: (_, value) => {
        const objectiveArray = value.objective?.split(',').map(s => s.trim()) || [];
        const hasOneId = objectiveArray.includes("one-id");
        const hasOneIdRA = objectiveArray.includes("one-id-ra");
        const showButton = hasOneId && hasOneIdRA;
        return showButton ? (
          <Button
            onClick={async () => {
              const file_id = value.excel._id
              try {
                await axios({
                  method: 'GET',
                  url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/send-mail-oneid-ra?biz_id=${business_id}&file_id=${file_id}`,
                });
                Swal.fire({
                  title: 'ส่ง Email อีกครั้งสำเร็จ',
                  icon: 'success'
                })
              } catch (error) {
                const status = error?.response?.status;
                if (status === 401) {
                  navigate(`/${params.prefix}`);
                } else {
                  Swal.fire({
                    title: 'ส่ง Email อีกครั้งไม่สำเร็จ',
                    icon: 'error'
                  })
                }
              }
            }}
          >
            Resend-Email
          </Button>
        ) : (
          <p style={{ color: "#ff0000" }}>ไม่สามารถส่ง Email อีกครั้งได้</p>
        );
      }
    },
    {
      title: 'จัดการ',
      dataIndex: 'manage',
      width: 30,
      render: (_, record, index) => {
        return (
          <>
            <Button onClick={() => {
              dispatch(setManageMemberStep({
                manageMemberStep: 'history_detail'
              }))
              dispatch(setHistoryDetail({
                historydetail: record.excel
              }))
            }}
              style={{ backgroundColor: '#F3F5FA', color: '#3776E9' }}>
              ดูรายละเอียด
            </Button>
          </>
        )
      },
    },
  ];

  return (
    <>
      {
        loading ?
          <LoadingComponent />
          :
          <>
            <Row>
              <Col xxl={3} xl={4} lg={4} md={12} sm={12} xs={12}>
                <Card
                  style={{
                    width: '100%',
                    borderRadius: '16px',
                    marginRight: '20px',
                    marginBottom: '10px',
                    cursor: 'pointer',
                  }}
                  onMouseOver={({ target }) => {
                    target.style.transform = `scale(1.1)`
                    target.style.transition = `all .5s`
                  }}
                  onMouseOut={({ target }) => {
                    target.style.transform = `scale(1.0)`
                  }}
                  onClick={() => {
                    setData(dataDefault)
                  }}
                >
                  <Row>
                    <Col className='align-self-center' style={{ textAlign: 'center' }}>
                      <FormatListBulletedIcon style={{
                        backgroundColor: '#3776E9',
                        borderRadius: '50%',
                        fontSize: '52px',
                        padding: '5px',
                        color: '#fff',
                      }} />
                    </Col>
                    <Col className='align-self-center' style={{ textAlign: 'center' }}>
                      <span style={{
                        fontSize: '31px',
                        color: '#3776E9',
                        fontWeight: '700'
                      }}>
                        {all_history}
                      </span>
                      <br />
                      รายการทั้งหมด
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col xxl={3} xl={4} lg={4} md={12} sm={12} xs={12}>
                <Card
                  style={{
                    width: '100%',
                    borderRadius: '16px',
                    marginBottom: '10px',
                    cursor: 'pointer',
                  }}
                  onMouseOver={({ target }) => {
                    target.style.transform = `scale(1.1)`
                    target.style.transition = `all .5s`
                  }}
                  onMouseOut={({ target }) => {
                    target.style.transform = `scale(1.0)`
                  }}
                  onClick={() => {
                    let members = [...dataDefault]
                    setData(members.filter(member => member.status === true))
                  }}
                >
                  <Row>
                    <Col className='align-self-center' style={{ textAlign: 'center' }}>
                      <CheckIcon style={{
                        backgroundColor: '#F3F5FA',
                        borderRadius: '50%',
                        fontSize: '52px',
                        padding: '5px',
                        color: '#53BE35',
                      }} />
                    </Col>
                    <Col className='align-self-center' style={{ textAlign: 'center' }}>
                      <span style={{
                        fontSize: '31px',
                        color: '#53BE35',
                        fontWeight: '700'
                      }}>
                        {success_history}
                      </span>
                      <br />
                      รายการที่สำเร็จ
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col xxl={3} xl={4} lg={4} md={12} sm={12} xs={12}>
                <Card
                  style={{
                    width: '100%',
                    borderRadius: '16px',
                    marginBottom: '10px',
                    cursor: 'pointer',
                  }}
                  onMouseOver={({ target }) => {
                    target.style.transform = `scale(1.1)`
                    target.style.transition = `all .5s`
                  }}
                  onMouseOut={({ target }) => {
                    target.style.transform = `scale(1.0)`
                  }}
                  onClick={() => {
                    let members = [...dataDefault]
                    setData(members.filter(member => member.status === false))
                  }}
                >
                  <Row>
                    <Col className='align-self-center' style={{ textAlign: 'center' }}>
                      <CloseIcon style={{
                        backgroundColor: '#F3F5FA',
                        borderRadius: '50%',
                        fontSize: '52px',
                        padding: '5px',
                        color: '#F37959',
                      }} />
                    </Col>
                    <Col className='align-self-center' style={{ textAlign: 'center' }}>
                      <span style={{
                        fontSize: '31px',
                        color: '#F37959',
                        fontWeight: '700'
                      }}>
                        {fail_history}
                      </span>
                      <br />
                      รายการที่ไม่สำเร็จ
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
            <br />
            <Table
              columns={columns}
              dataSource={data}
              scroll={{
                x: 1400,
                y: 400,
              }}
              locale={customLocale}
              pagination={{
                current: page,
                pageSize: pageSize,
                onChange: (page, pageSize) => {
                  setPage(page)
                  setPageSize(pageSize)
                }
              }}
            />
          </>
      }
    </>
  );
}
export default AddHistory;